// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"e36c826c","548":"146cbfae","814":"0448236c","825":"8e4c998a"}[chunkId] + ".chunk.js";
};